module.exports = __webpack_public_path__ + "static/media/20ECE13.ebf9bcd0.jpg";